import Axios from "axios";
import config from "../app.config";

export var ruleService;
export default ruleService = {
    getFolderReceiveMail,
    addRuleReceiveMail,
    getRuleReceiveMail,
    deleteRuleReceiveMail,
    fetchRule,
    updateRuleReceiveMail,
    applyRuleReceiveMail,
}

async function getFolderReceiveMail(data) {
    return await Axios.get(`${config.LOCAL_API_URL}/getFolderReceiveMail/${data}`)
      .then(response => {
          if(response.data) {
              return Promise.resolve(response.data);
          } else {
              return Promise.reject(response);
          }
      }).catch(error =>{
          return Promise.reject(error);
      })
  }

  async function addRuleReceiveMail(data) {
    let mailBox = data.mailBox
    return await Axios.post(`${config.LOCAL_API_URL}/addRuleReceiveMail/${mailBox}`, {data})
      .then(response => {
        if (response.data) {
          return Promise.resolve(response.data);
        } else {
          return Promise.reject(response);
        }
      }).catch(error => {
        return Promise.reject(error);
      })
  }

  async function getRuleReceiveMail(data) {
    return await Axios.get(`${config.LOCAL_API_URL}/getRuleReceiveMail/${data}`)
      .then(response => {
          if(response.data) {
              return Promise.resolve(response.data);
          } else {
              return Promise.reject(response);
          }
      }).catch(error =>{
          return Promise.reject(error);
      })
  }

  async function deleteRuleReceiveMail(data) {
    let mailBox = data.mailBox
    let id = data.id
    return await Axios.delete(`${config.LOCAL_API_URL}/deleteRuleReceiveMail/${mailBox}`, {
      data: { id }
    })
      .then(response => {
        if (response.data) {
          return Promise.resolve(response.data);
        } else {
          return Promise.reject(response);
        }
      }).catch(error => {
        return Promise.reject(error);
      })
  }

  async function fetchRule(id){
    return await Axios.get(`${config.LOCAL_API_URL}/rule/` + id)
    .then(response => {
        if(response.data.success || response.data.status) return Promise.resolve(response.data)
        else return Promise.reject(response.data)
    })
    .catch(error =>{
        return Promise.reject(error.response.data);
    })
}

async function updateRuleReceiveMail(data) {
    let mailBox = data.mailBox
    return await Axios.put(`${config.LOCAL_API_URL}/updateRuleReceiveMail/${mailBox}`, data)
      .then(response => {
        if (response.data) {
          return Promise.resolve(response.data);
        } else {
          return Promise.reject(response);
        }
      }).catch(error => {
        return Promise.reject(error);
      })
  }

  async function applyRuleReceiveMail(data) {
    let mailBox = data.mailBox
    let id = data.id
    return await Axios.post(`${config.LOCAL_API_URL}/applyRuleReceiveMail/${mailBox}`,{id : id})
      .then(response => {
          if(response.data) {
              return Promise.resolve(response.data);
          } else {
              return Promise.reject(response);
          }
      }).catch(error =>{
          return Promise.reject(error);
      })
  }